export const HOME_PAGE_TITLE = 'Seguro Viagem - O Maior Comparador de Seguro Viagem do Brasil'
export const SEARCH_PAGE_TITLE = 'Seguro Viagem - Resultado de pesquisa'
export const COMPARISON_PAGE_TITLE = 'Seguro Viagem - Comparador'
export const DETAIL_PAGE_TITLE = 'Seguro Viagem - Detalhes do Plano'
export const PURCHASE_PAGE_TITLE = 'Seguro Viagem - Pagamento'



// WEBPACK FOOTER //
// ./src/constants.js